// extracted by mini-css-extract-plugin
module.exports = {"trigger-button":"style-trigger-button-3oYrR","menu-button":"style-menu-button-XpwBw"};